module.exports = __webpack_public_path__ + "10cec8cb78f5f729e7f0b1a8e4e0f834.png";